import { z } from "zod";

export const User = z.object({
  id: z.string(),
  kudos_given: z.number(),
  kudos_received: z.number(),
  display_name: z.string().optional(),
  image_url: z.string().optional(),
  email: z.string().optional(),
  admin: z.boolean().optional(),
});

export type User = z.infer<typeof User>;
